// extracted by mini-css-extract-plugin
export default {"Nav":"Nav_Nav__21XAS","Nav_phone":"Nav_Nav_phone__1HgxI","Nav__link":"Nav_Nav__link__2mlVG","Nav_desktop":"Nav_Nav_desktop__57DjZ","Nav__link_active":"Nav_Nav__link_active__2LbS9"};